import React, { useEffect } from 'react';
import { Channel } from '../../shared/types';
import { Loader } from 'neon-design-system';
import { Grid } from '@material-ui/core';
import ChannelCard from '../containers/client/ChannelCardNew';
import { baseUrls } from '../../utils/baseUrls.utils';

interface ChannelPreviewListProps {
	onDataLoaded?: (totalCount: number) => void;
	channels: Channel[];
	loading: boolean;
}

const ChannelPreviewList = ({ onDataLoaded, channels, loading }: ChannelPreviewListProps) => {
	useEffect(() => {
		if (!loading && onDataLoaded) {
			onDataLoaded?.(channels.length ?? 0);
		}
	}, [channels, loading, onDataLoaded]);

	if (loading) return <Loader />;
	if (!channels?.length) return null;

	return (
		<Grid container spacing={2}>
			{channels.map((channel: Channel) => {
				if (!channel) return <></>;

				return (
					<Grid key={channel._id} item xs={12} sm={6} md={4}>
						<ChannelCard
							name={channel.name}
							owner={channel.owner.name}
							url={`${baseUrls.browse.channelMain}/${channel._id}`}
							image={channel.coverImage}
							premium={channel.type === 'premium'}
							isSubscribed={channel.isCurrentUserSubscribed}
						/>
					</Grid>
				)
			})}
		</Grid>
	);
};

export default ChannelPreviewList;
